<template>
    <Tooltip :title="tooltipTile" v-if="tooltipTile && $root.features?.applications?.triggers">
        <span class="status-badge" :class="className"></span>
    </Tooltip>
</template>
<script>
import Tooltip from '@/components/common/layout/Tooltip.vue';
export default {
    components: {
        Tooltip,
    },
    props: {
        profile: Object,
    },
    emits: [
    ],
    computed: {
        tooltipTile() {
            if (!this.profile?.triggerStatus?.name) {
                return this.i18n('Unknown Status');
            }

            return this.profile.triggerStatus.name;
        },
        className() {
            if (!this.profile?.triggerStatus?.name) {
                return '';
            }

            return 'status-' + this.profile.triggerStatus.code;
        }
    },
};
</script>
<style scoped>
span.status-badge {
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: #6c757d;
}

span.status-badge.status-queued,
span.status-badge.status-in-progress {
    background-color: #ffc107;
}

span.status-badge.status-completed {
    background-color: #28a745;
}

span.status-badge.status-failed {
    background-color: #dc3545;
}

span.status-badge.wont-do {
    background-color: #dc3545;
}
</style>